module.exports = __webpack_public_path__ + "img/w3.c4caf252.png";